import React from 'react';
import clsx from 'clsx';
import { is } from '../../../services';
import { hashClass } from '../../../helpers';
import { useTrilogyContext } from '../../../context';
/**
 * Navbar link Component
 * @param children {ReactNode} Children link if not content
 * @param className {string} Additionnal css classes
 * @param to {string} link to url
 * @param content {string} Text content if not children
 * @param highlighted {boolean} Highlighted link
 * @param onClick {Function} onClick Event
 * @param routerLink Custom Router Link as props
 */
const NavbarLink = ({ children, className, to, highlighted, content, onClick, routerLink, testId, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('navbar-link', highlighted && is('highlighted'), className));
    if (routerLink && to) {
        const RouterLink = (routerLink ? routerLink : 'a');
        return (React.createElement(RouterLink, { "data-testid": testId, onClick: onClick, className: classes, to: to || '', ...others },
            content && !children && content,
            !content && children && children));
    }
    return (React.createElement("a", { "data-testid": testId, onClick: onClick, href: to, className: classes, ...others },
        content && !children && content,
        !content && children && children));
};
export default NavbarLink;
//# sourceMappingURL=NavbarLink.js.map